import { RefObject } from "preact";
import { useEffect, useMemo, useRef } from "preact/hooks";
import { captureUrlAndUtmData } from "../utils";

export const useSendUrlUtmData = (iframe: RefObject<HTMLIFrameElement | null>) => {
  const capturedData = useMemo(() => captureUrlAndUtmData(), []);
  const sent = useRef(false);

  useEffect(() => {
    if (!iframe.current) return;

    function sendUrlUtmData() {
      if (sent.current) return;
      // Send URL and UTM data to the iframe when it opens
      const targetOrigin = process.env.WEBSITE_DOMAIN || '*';
      try {
        const message = JSON.stringify({
          type: 'widget_url_utm_data',
          data: capturedData,
        });
        iframe.current?.contentWindow?.postMessage(message, targetOrigin);
        sent.current = true;
      } catch (error) {
        console.error('Failed to send URL/UTM data to iframe:', error);
      }
    }

    iframe.current.addEventListener('load', sendUrlUtmData);
    return () => {
      iframe.current?.removeEventListener('load', sendUrlUtmData);
    }
  }, [capturedData]);
}

